import { RoundButton } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ETestId } from '../../../common/constants/testId';

interface ILikeButtonContainerProps {
  isFavorite: boolean;
  darkButton?: boolean;
  onAdd?(): void;
  onRemove?(): void;
}

export const FavoriteButton = ({ isFavorite, onAdd, onRemove }: ILikeButtonContainerProps) => {
  const onClick = React.useMemo(() => (isFavorite ? onRemove : onAdd), [isFavorite, onAdd, onRemove]);

  const buttonTitle = isFavorite ? 'Удалить из избранного' : 'Добавить в избранное';
  const icon = isFavorite ? (
    <span>
      <IconToggleHeartOn16 color="error_100" aria-label="heartActive" display="block" />
    </span>
  ) : (
    <IconToggleHeartOff16 color="white_100" aria-label="heart" display="block" />
  );

  return (
    <RoundButton
      theme="fill_dark"
      size="M"
      onClick={onClick}
      title={buttonTitle}
      icon={icon}
      data-testid={ETestId.FavoriteButton}
    />
  );
};
